import { isFreeProduct } from "../../../common/badge/FreeBadge";
import CatalogTileCard from "../../../common/catalog/CatalogTileCard";
import { resolveCatalogInstructor } from "../../../common/catalog/catalogInstructorDisplay";

export default function Workshop({ workshop }) {
	const instructor = resolveCatalogInstructor(workshop);

	return (
		<CatalogTileCard
			to={`/workshop_detail/${workshop.id}/`}
			title={workshop?.title ?? ""}
			imageUrl={workshop?.image_url}
			actionLabel="مشاهده کارگاه"
			instructorItem={workshop}
			subtitleMuted={instructor.isEmpty}
			showFreeBadge={isFreeProduct(workshop)}
		/>
	);
}
